<!--多选题-->
<template>
  <div class="uni-question-wrap">
    <div class="subject">
      <div class="stem" v-if="!isHideName">
        <div class="nameText">
          <!-- 编号 -->
          <em
            v-if="$route.path === '/practiceAnalysis'"
            :class="`${toggleClass(datas.is_make)}`"
            >{{ datas.sort }}</em
          >
          <em v-else>{{ datas.sort }}</em>

          <!-- 题目 -->
          <p style="flex: 1">
            <!-- <span>[{{ qStyle[datas.question_style] }}]</span> -->
            <span>[{{ datas.question_title }}]</span>
            <i class="mal10">
              <!-- v-html="datas.title" -->
              <span style="color: #343434 !important; white-space: pre-wrap;">{{ datas.title }}</span>
              (本题{{ datas.fraction }}分)
            </i>
            <i v-if="datas.title_thumb">(点击图片放大)</i>
          </p>
        </div>

        <!-- 查看解析 -->
        <div class="operation" @click="showAnalysis" v-if="isAnalysis">
          <div class="uni-cursor" :class="{ active: isAnalysis }">
            <i class="iconfont iconhuabanfuben"></i>
            <span>查看解析</span>
          </div>
        </div>
      </div>

      <!-- 音频 -->
      <div class="audioDiv" v-if="datas.audio_url">
        <audio
          class="sourceAudio"
          controls="controls"
          v-for="(itemAudio, indexAudio) in datas.audio_url.split(',')"
          :key="indexAudio"
        >
          <source :src="itemAudio" type="audio/ogg" />
          Your browser does not support the audio element.
        </audio>
      </div>

      <!-- 题目图片 -->
      <el-image
        v-if="datas.title_thumb"
        class="mat20 mal20"
        style="max-width: 200px; color: #fff"
        fit="contain"
        :src="datas.title_thumb"
        :preview-src-list="[datas.title_thumb]"
      />

      <!-- 答案选项 -->
      <div class="radio-group">
        <el-checkbox-group
          :disabled="isDisabled"
          v-model="answer"
          @change="theRadio"
        >
          <el-checkbox
            class="answer"
            v-for="(item, index) in datas.item"
            :key="index"
            :label="
              JSON.stringify({
                option: item.option,
                key: item.key,
              })
            "
          >
            <div class="topic-content">
              <span class="span"> {{ item.option }}.</span>
              <span v-if="item.img === ''">{{ item.value }}</span>
              <el-image
                class="mal10"
                style="width: 50px;height: 50px; color: #fff"
                v-if="item.img"
                fit="contain"
                :src="item.img"
                :preview-src-list="[item.img]"
              />
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
import { questionMixin } from "./common.js";
export default {
  name: "ChoiceMultiple",
  mixins: [questionMixin],
  data() {
    return {
      answer: [],
    };
  },
  watch: {
    "datas.choice_correct_item"(newVal) {
      if (newVal) {
        this.answer = JSON.parse(newVal).map((item) => {
          return JSON.stringify(item);
        });
      } else {
        this.answer = [];
      }
    },
  },
  mounted() {
    const choice_correct_item = this.datas.choice_correct_item;
    if (choice_correct_item) {
      this.answer = JSON.parse(choice_correct_item).map((item) => {
        return JSON.stringify(item);
      });
    } else {
      this.answer = [];
    }
  },
  methods: {
    theRadio(val) {
      let sortVal = val
        .map((item) => {
          return JSON.parse(item);
        })
        .sort((a, b) => {
          return a.option.localeCompare(b.option);
        });
      this.datas.choice_correct_item = JSON.stringify(sortVal);
      this.$emit("next");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./common.scss";
</style>
